export default class BillingContactObj {
    phones
    name
    id
    emails
    description

    constructor () {
      this.phones = []
      this.emails = []
    }
}
